module.exports = __webpack_public_path__ + "static/img/18.c326c0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/18.png
// module id = UxrL
// module chunks = 0